import { FC, ReactElement } from 'react'
import { AuthHome } from './pages/auth/auth-home'
import { AuthProvider } from './contexts/auth.context'

export const Auth: FC = (): ReactElement => (
  <AuthProvider>
    <AuthHome />
  </AuthProvider>
)
